var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 466.5 484.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#d6d8e5;}.cls-1{opacity:0.4;}.cls-2{fill:#b1b4c4;}.cls-4{fill:#9ea1af;}.cls-5{fill:#c4c7d6;}.cls-6{fill:#e4e7f2;}.cls-7{fill:#fff;}.cls-8{fill:#e9eaf2;}.cls-9{fill:#8c50ff;}.cls-10{fill:#38226d;}.cls-11{fill:#9c73ff;}.cls-12{fill:#ffcea9;}.cls-13{fill:#f4f4f4;}.cls-14{fill:#3a2c6d;}.cls-15{fill:#ededed;}.cls-16{fill:#2ab7ca;}.cls-17{fill:#259ca5;}.cls-18{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_30);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_30",
    x1: 186.47,
    y1: 182.71,
    x2: 87.09,
    y2: 125.33,
    gradientTransform: "translate(95.34 -47.76) rotate(30)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Analytics_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monitor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288,383.5l-58.21-33.61c-4.2-2.42-3.67-6.66,1.18-9.45l37.71-21.78L342.12,361l-37.71,21.78C299.57,385.62,292.24,385.92,288,383.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.29,381l-58.21-33.61c-4.2-2.42-3.67-6.66,1.18-9.45L273,316.16l73.4,42.38-37.71,21.78C303.82,383.12,296.49,383.42,292.29,381Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "346.38 358.55 346.38 356.32 342.99 358.28 346.38 358.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "231.25 343.38 231.25 341.13 234.73 342.57 231.25 343.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M292.29,378.77l-58.21-33.6c-4.2-2.43-3.67-6.66,1.18-9.46L273,313.94l73.4,42.38-37.71,21.77C303.82,380.89,296.49,381.2,292.29,378.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "273.17 314.04 264.08 283.9 338.29 326.46 346.38 356.32 273.17 314.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M344.22,357.56l2.15-1.24-3.19-2.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "270.82 315.17 261.74 285.03 335.95 327.6 344.22 357.56 270.82 315.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M459.2,408.36,172,242.52c-4-2.32-7.3-8.57-7.3-13.94V6.39c0-5.37,3.27-7.84,7.3-5.51L459.2,166.72c4,2.32,7.3,8.56,7.3,13.93v222.2C466.5,408.22,463.23,410.69,459.2,408.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "460.68 410.65 463.86 408.82 462.49 399.38 460.68 410.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.15,2.24l3.13-1.8L171.78,3s-4.79.73-4.91.71S164.15,2.24,164.15,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M456.57,409.88,169.32,244c-4-2.32-7.29-8.56-7.29-13.94V7.91c0-5.37,3.27-7.84,7.29-5.51L456.57,168.24c4,2.32,7.29,8.56,7.29,13.94V404.37C463.86,409.74,460.6,412.21,456.57,409.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M456.06,410.17,168.82,244.33c-4-2.33-7.3-8.57-7.3-13.94V8.2c0-5.37,3.27-7.84,7.3-5.51L456.06,168.53c4,2.32,7.3,8.56,7.3,13.93v222.2C463.36,410,460.09,412.5,456.06,410.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M459.41,396.66,165.17,226.78l.15-217.69c0-2.23,1.57-3.13,3.5-2L456.06,172.91a7.75,7.75,0,0,1,3.5,6.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M206.7,79.05,180,63.61a3.66,3.66,0,0,1-1.52-2.91V30.36c0-1.12.68-1.63,1.52-1.15L206.7,44.66a3.62,3.62,0,0,1,1.52,2.9V77.9C208.22,79,207.54,79.54,206.7,79.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M243.78,100.46,217,85a3.66,3.66,0,0,1-1.52-2.91V51.77c0-1.12.68-1.63,1.52-1.15l26.75,15.45A3.62,3.62,0,0,1,245.3,69V99.31C245.3,100.43,244.62,101,243.78,100.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M280,121.35,253.2,105.9a3.62,3.62,0,0,1-1.52-2.9V72.66c0-1.12.68-1.64,1.52-1.15L280,87a3.62,3.62,0,0,1,1.52,2.9V120.2C281.47,121.32,280.79,121.83,280,121.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M206.7,121.87,180,106.43a3.66,3.66,0,0,1-1.52-2.91V73.18c0-1.12.68-1.63,1.52-1.15L206.7,87.47a3.66,3.66,0,0,1,1.52,2.91v30.34C208.22,121.84,207.54,122.36,206.7,121.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M243.78,143.28,217,127.84a3.66,3.66,0,0,1-1.52-2.91V94.59c0-1.12.68-1.63,1.52-1.15l26.75,15.44a3.66,3.66,0,0,1,1.52,2.91v30.34C245.3,143.25,244.62,143.77,243.78,143.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M247.43,141.27l-26.75-15.45a3.62,3.62,0,0,1-1.52-2.9V92.58c0-1.12.68-1.64,1.52-1.15l26.75,15.44a3.66,3.66,0,0,1,1.52,2.91v30.34C249,141.24,248.27,141.75,247.43,141.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M280,164.16,253.2,148.72a3.62,3.62,0,0,1-1.52-2.9V115.47c0-1.11.68-1.63,1.52-1.14L280,129.77a3.62,3.62,0,0,1,1.52,2.9V163C281.47,164.13,280.79,164.65,280,164.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M206.7,165.59,180,150.15a3.62,3.62,0,0,1-1.52-2.9V116.9c0-1.11.68-1.63,1.52-1.14L206.7,131.2a3.62,3.62,0,0,1,1.52,2.9v30.35C208.22,165.56,207.54,166.08,206.7,165.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M280,232.36,180,174.63a3.66,3.66,0,0,1-1.52-2.91v-7c0-1.12.68-1.64,1.52-1.15l100,57.74a3.62,3.62,0,0,1,1.52,2.9v7C281.47,232.33,280.79,232.85,280,232.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M254.27,234,180.4,191.39a3.62,3.62,0,0,1-1.52-2.9V185c0-1.12.68-1.64,1.52-1.15l73.87,42.64a3.66,3.66,0,0,1,1.52,2.91v3.47C255.79,234,255.11,234.52,254.27,234Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M254.27,247.2,180.4,204.55a3.62,3.62,0,0,1-1.52-2.9v-3.47c0-1.12.68-1.63,1.52-1.15l73.87,42.64a3.66,3.66,0,0,1,1.52,2.91v3.47C255.79,247.17,255.11,247.68,254.27,247.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M240.33,252.32,180.4,217.71a3.62,3.62,0,0,1-1.52-2.9v-3.47c0-1.12.68-1.63,1.52-1.15l59.93,34.6a3.66,3.66,0,0,1,1.52,2.91v3.47C241.85,252.29,241.17,252.8,240.33,252.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M444.61,328,300.24,244.68a3.62,3.62,0,0,1-1.52-2.9v-7c0-1.12.68-1.63,1.52-1.15L444.61,317a3.62,3.62,0,0,1,1.52,2.9v7C446.13,328,445.45,328.52,444.61,328Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M430.38,336.32,300.7,261.44a3.62,3.62,0,0,1-1.52-2.9v-3.47c0-1.12.68-1.63,1.52-1.15l129.68,74.87a3.66,3.66,0,0,1,1.52,2.91v3.47C431.9,336.29,431.22,336.8,430.38,336.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M430.38,349.48,300.7,274.61a3.66,3.66,0,0,1-1.52-2.91v-3.47c0-1.12.68-1.63,1.52-1.15L430.38,342a3.62,3.62,0,0,1,1.52,2.9v3.47C431.9,349.45,431.22,350,430.38,349.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M406.34,348.76l-105.64-61a3.66,3.66,0,0,1-1.52-2.91v-3.47c0-1.12.68-1.63,1.52-1.15l105.64,61a3.65,3.65,0,0,1,1.52,2.9v3.47C407.86,348.73,407.17,349.24,406.34,348.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M243.78,187,217,171.56a3.62,3.62,0,0,1-1.52-2.9V138.31c0-1.11.68-1.63,1.52-1.14l26.75,15.44a3.62,3.62,0,0,1,1.52,2.9v30.35C245.3,187,244.62,187.49,243.78,187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M280,207.89,253.2,192.44a3.62,3.62,0,0,1-1.52-2.9V159.2c0-1.12.68-1.64,1.52-1.15L280,173.49a3.66,3.66,0,0,1,1.52,2.91v30.34C281.47,207.86,280.79,208.37,280,207.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M444.61,303,300.24,219.6a3.62,3.62,0,0,1-1.52-2.9V169.16c0-1.12.68-1.64,1.52-1.15l144.37,83.35a3.66,3.66,0,0,1,1.52,2.91v47.54C446.13,302.93,445.45,303.44,444.61,303Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M320,161.85c-12.26-7.08-22.24-24.35-22.24-38.51s10-19.91,22.24-12.84,22.23,24.36,22.23,38.51S332.25,168.93,320,161.85Zm0-43.93c-8.72-5-15.81-.93-15.81,9.13s7.09,22.35,15.81,27.38,15.81.94,15.81-9.13S328.7,123,320,117.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M320,161.85c-12.26-7.08-22.24-24.35-22.24-38.51s10-19.91,22.24-12.84v7.42c-8.72-5-15.81-.93-15.81,9.13s7.09,22.35,15.81,27.38,15.81.94,15.81-9.13l6.42,3.71C342.22,163.17,332.25,168.93,320,161.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M371.86,191.81c-12.26-7.08-22.23-24.36-22.23-38.51s10-19.92,22.23-12.84,22.23,24.35,22.23,38.51S384.12,198.89,371.86,191.81Zm0-43.93c-8.72-5-15.81-.94-15.81,9.13s7.09,22.34,15.81,27.38,15.81.94,15.81-9.13S380.58,152.91,371.86,147.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M371.86,191.81c-12.26-7.08-22.23-24.36-22.23-38.51s10-19.92,22.23-12.84v7.42c-8.72-5-15.81-.94-15.81,9.13s7.09,22.34,15.81,27.38c3.24,1.87,6.35,2.54,9,2l3.67,8.21C380.8,195.39,376.42,194.44,371.86,191.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M423.73,221.75c-12.26-7.08-22.23-24.36-22.23-38.51s10-19.92,22.23-12.84S446,194.75,446,208.91,436,228.83,423.73,221.75Zm0-43.93c-8.71-5-15.81-.94-15.81,9.13s7.1,22.34,15.81,27.38,15.81.94,15.81-9.13S432.45,182.85,423.73,177.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M404.38,197.56a41,41,0,0,1-2.88-14.32c0-14.16,10-19.92,22.23-12.84v7.42c-8.71-5-15.81-.94-15.81,9.13A29,29,0,0,0,410,197.12Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 339.59,
    cy: 466.72,
    rx: 22.58,
    ry: 13.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 100.88,
    cy: 471.86,
    rx: 22.58,
    ry: 13.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 22.58,
    cy: 353.57,
    rx: 22.58,
    ry: 13.04
  }), /*#__PURE__*/React.createElement("g", {
    id: "Men_14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M350.82,463.6c-1.47,1.19-3.64.1-3.75.21a63.19,63.19,0,0,1-5.42,4.51c-.91.72-2.34,1.69-2.08,3.07.46,2.48,4.42,1.72,5.92,1s2.71-2,4.13-2.89c1-.63,2-.95,2.16-2.23C351.87,466.46,351.08,463.57,350.82,463.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M351.76,466.72c-.2,1.22-1.18,1.56-2.18,2.18-1.44.89-2.7,2.18-4.2,2.93s-4.82,1.4-5.79-.37c.53,2.39,4.42,1.64,5.9.89s2.71-2,4.13-2.89c1-.63,2-.95,2.16-2.23A3.23,3.23,0,0,0,351.76,466.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M338.07,458.86c-1.47,1.2-4-.11-4.15,0a54.07,54.07,0,0,1-4.84,4.37c-.91.72-2.34,1.69-2.08,3.07.46,2.47,4.42,1.71,5.92,1s2.71-2,4.13-2.89c1-.63,2-1,2.16-2.23C339.3,461.37,338.33,458.83,338.07,458.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M339.16,461.8C339,463,338,463.36,337,464c-1.44.89-2.71,2.18-4.2,2.94s-4.83,1.39-5.8-.38c.53,2.39,4.42,1.64,5.9.89s2.72-2,4.13-2.89c1-.63,2-1,2.16-2.22A1.91,1.91,0,0,0,339.16,461.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-9",
    d: "M350.9,409.39c-.07,2.22-.76,11.86-1.07,17s-.38,11.36-.38,11.36.88,3.72,1.45,8.09,0,18.17,0,18.17a3.47,3.47,0,0,1-3.76,0s-2.35-11-3.44-16-1.27-7.85-1.84-10.93c-.68-3.73-2.16-21.14-2.16-21.14l-.59,0-1.57,19.65a21.66,21.66,0,0,1,1,4.46c.43,3.21-.45,19.31-.45,19.31a3.88,3.88,0,0,1-4.06-.17s-3.93-21.33-3.93-24.57c0-2.15.37-30.46.37-30.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-12",
    d: "M345.58,366.47s-.25,4.84-.14,5.27,2.22,1.85,2.84,2.35-3.35,4.42-5.28,5.31-8-1.45-8.14-4.45,1-5.52,2-5.65S345.58,366.47,345.58,366.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M332.32,375.45c-.29-2.13,1.12-4.16-.24-5.86-4.78,4.68-4.18,17.08-5.26,25-3.55,3.71-10.68,7.36-12.69,8.27-.37.16-.68.34-.61.73a8.85,8.85,0,0,0,1.66,3.63c4.72-2,8.12-3.2,14-8.8a13,13,0,0,0,1.5-2C332.38,391.42,332.8,379.14,332.32,375.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-13",
    d: "M346.12,372.57s-3.51,5.24-8.42,5.73c-1.54-1.52-1.68-6.94.46-8.68,0,0-2-1.58-3.32-1.28a6.93,6.93,0,0,0-3,3.87,31.53,31.53,0,0,0-1.73,11.2c.08,5.14,0,20.84,0,20.84s.69,3.32,5.13,5.79,7.72,2.71,10.73,2c2.48-.58,4.53-1.46,5.39-3.26-.22-3.6-1.83-13-1.23-17.52s1.56-7.91,1.8-11.57-.48-3.59-2.31-4.89A28.56,28.56,0,0,0,346.12,372.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_4",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-12",
    d: "M334.62,359.25h0c.58-3.76,3.29-6.61,7.16-6.39a7.47,7.47,0,0,1,7.05,7.88,7.38,7.38,0,0,1-3.25,5.72,8,8,0,0,1-.6,1.65c-1.37,1.6-5.52,2.59-6.71,2.42a3.55,3.55,0,0,1-3.09-2.53C333.9,365.05,334.3,361.11,334.62,359.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M345.58,366.46h0l-.36-3.27s2.68-6.94-3.65-5.61c-4.18.88-5.23,1.26-6.5-1.54s3.21-5.33,8.54-4.63a7.36,7.36,0,0,1,6.59,7.47C350.06,360.94,349.51,365.12,345.58,366.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M353,377.54c-1.83-.52-.43-.09-1.83-.52-4.78,4.68-4.19,12.71-5.27,20.65-2.64,4.36-12.43,10.27-12.43,10.27-.12.85.17,1.1,1.23,2.8a42.07,42.07,0,0,0,14.56-9.39c.24-.22.58-.28.68-.58C351.61,395.71,353.48,381.23,353,377.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "309.42 387.32 316.54 411.66 332.15 417.89 326.46 394.19 309.42 387.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M335.92,408.12c-.23-.83-.83-.63-1.51-.42a3.89,3.89,0,0,1-2.31.2,7,7,0,0,1-1.66-1.12,2,2,0,0,0-1-.29c0,.21.36,1.44.36,1.44s-3.42,0-3.77,0a.57.57,0,0,0-.54.94,1.6,1.6,0,0,1-.23,0c-.7-.16-1,.92-.3,1.08a5.58,5.58,0,0,0,.57.08c-.46.18-.57.94,0,1l.17,0a.49.49,0,0,0,.26,0l.1,0a.62.62,0,0,0,.52.72c1.67.22,4.13.89,5.64-.49a9.67,9.67,0,0,0,3-.82C336.17,410.05,336.2,409.11,335.92,408.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M318.84,406.13l-.24,0a.58.58,0,0,0-.33-1c-.35,0-3.87-.73-3.87-.73l-.43-1.45c0-.08-.61.29-.63.3a2.38,2.38,0,0,0-1.06,1.76,3.74,3.74,0,0,0,1,2.72,3.5,3.5,0,0,0,2.39,1c.42,0,.83,0,1.2.08a.62.62,0,0,0,.66-.61l.11,0a.54.54,0,0,0,.25,0h.18c.6,0,.65-.74.24-1,.19,0,.38,0,.58,0C319.62,407.24,319.55,406.12,318.84,406.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M330.33,378.62a3.79,3.79,0,0,1-2.56-1.14c.14-1.8,2.44-8.63,7.07-9.14a8.61,8.61,0,0,0-2.89,3.5A45.28,45.28,0,0,0,330.33,378.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M353.83,387.65s-4.61,1.59-7.86-1.08c-.35-.61,1.88-8.45,1.88-8.45s1.94-4,5-2.42S353.83,387.65,353.83,387.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Men_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M85.05,384.66s.64,9.57,1.89,10.95,5.5,2.32,5.5,2.32l3.28,5.39s-3-17.13-3.64-17.54S85.05,384.66,85.05,384.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-15",
    d: "M91.34,374a3.56,3.56,0,0,0-4.55,1.38c-1.21,2-2.46,8.84-2.57,10,0,0,1.69,2.34,4.22,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M101,469.61a7.05,7.05,0,0,0,5.3-.64c1.27,0,8.2-2.93,9.14-.44.83,2.18-2.17,4.2-3.77,4.59-3.5.85-6.09,2.59-7.5,2.89-1,.22-2.4.36-3.23-.46C100,474.56,100.06,470.91,101,469.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M104.21,475.4c1.41-.29,4-2,7.5-2.89,1.34-.32,3.65-1.79,3.89-3.54.31,2-2.4,3.79-3.89,4.15-3.5.85-6.09,2.59-7.5,2.89-1,.22-2.4.36-3.23-.46a1.92,1.92,0,0,1-.46-.84A4.19,4.19,0,0,0,104.21,475.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M90.25,466.24a7,7,0,0,0,5.3-.64c1.28,0,8.2-2.92,9.15-.43.82,2.18-2.18,4.2-3.78,4.59-3.5.84-6.09,2.59-7.49,2.88-1.05.22-2.41.37-3.24-.45C89.19,471.2,89.28,467.55,90.25,466.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M93.43,472c1.4-.3,4-2,7.49-2.89,1.34-.32,3.66-1.79,3.89-3.55.31,2-2.4,3.79-3.89,4.16-3.5.84-6.09,2.59-7.49,2.88-1.05.22-2.41.37-3.24-.45a2.09,2.09,0,0,1-.46-.84A4.21,4.21,0,0,0,93.43,472Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-9",
    d: "M89.49,446.76a41.85,41.85,0,0,1,1.6-7.58s-.48-6.55-.72-12.76c-.27-7-2.71-13.24-.79-18.86L111,412.33s-1,28.14-1.33,31.54a62.75,62.75,0,0,1-1,7.89c-1,5.45-2.07,17.65-2.07,17.65-2.3,1.34-5.67.24-5.67.24s0-15.27.13-19.2c.18-4.8.33-4.43.33-4.43l-.72-11.95-.47-5.94s-.6,4.36-1,8.25c-.34,3.4-1.16,6.47-2.08,12.8-.79,5.48-1.61,16.67-1.61,16.67-2.3,1.33-5.4.41-5.4.41S88.87,451.52,89.49,446.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-12",
    d: "M92.5,374.14c1.65.08,2.88.51,3.09,0a21.88,21.88,0,0,0,.38-2.59c-.19-.48-.36-1-.36-1-2.08-1.27-2.73-3.52-3-6.14-.46-4.47,2-8.38,6.42-8.85,4.21-.44,7.3,2.52,8.13,6.57.44,2,1.33,5.79.13,9.08-.67,1.85-1.53,3.31-2.39,3.59a18,18,0,0,1-2.49-.22h0s-.22,1.24-.37,2-.1,1.21,1.49,2.19-2.4,3-5,2.79-5.54-1.77-6.34-3.45C91.28,376.3,91.36,374.08,92.5,374.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-13",
    d: "M94.89,374.39c-.46,1.14.71,2.54,3.82,3.51s3.38-.28,3.38-.28a61.51,61.51,0,0,1,6,3.12c1.86,1.3,2.69,5.08,2.94,11.45.29,7.37.32,18.31.07,20.2,0,0-3.48,3.48-8,3.11s-12-4.32-13.79-7.37c0-6.46.81-7.51-.24-11.24-2.4-8.53-3.66-12-2.49-17.68,1-4.67,2.3-5.25,4.15-5.21A39,39,0,0,1,94.89,374.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M107.23,418.07,105,392.39l4.79-2.54,1.87,1.57L111,414.48h0l0,.64h0l0,.82s.1,1.94-3.56,4.26c0,0-.06-.61-.11-1.18h0l-.09-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_9",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-15",
    d: "M106.66,379.15c2.47,0,4,1.26,4.65,5.07s1,6.93,1,6.93a6.66,6.66,0,0,1-4.41,2.18c-3,.33-3.86-1.19-3.86-1.19s-.32-3.95-.48-6.64S103.6,379.21,106.66,379.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M107,361.56s3.86-5.87-4.51-7.07c-6-.86-9.92,3-10.37,7.23-.43,4,2.05,8.19,3.84,9.85a7.29,7.29,0,0,0,5.22-.63,29.41,29.41,0,0,0,.11-3.29S98.36,361.45,107,361.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Girl_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_10",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-14",
    d: "M22.66,235.93c-.88-1.42-7.6-2.35-9.81,3.34-.84,2.16-.71,7.68-1.41,11.14s-2.35,5.43-2.94,8.24.37,7.53,7.15,8.36,12-1.55,13.58-3.71,1.63-6.75,0-9.21-2.92-4.47-2.88-7.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M30.7,259.74S32.29,271,29.29,279s-2.18-2.05-2.18-2.05l.73-2.39s.6-9.18.35-11.43-.19-4.19-.35-4.37.59-.54.91-.58S30.7,259.74,30.7,259.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-14",
    d: "M18.22,234.94s5.06-1.45,8.12,1.28a7.52,7.52,0,0,1,2.17,7.49c-.41,1.6-1.23,3.78-2.5,3.9S18.22,234.94,18.22,234.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-12",
    d: "M16.29,248.74s.33,5.63.23,6-2.22.82-2.81,1.31,3.07,6.21,4.93,7.06,7.61-1.32,8-4.18c.37-2.64-1.64-4.69-2.42-5.4a11.4,11.4,0,0,0-1.59,0l-.17-2.74C20,250,16.29,248.74,16.29,248.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_13",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-13",
    d: "M15.51,255.33c-1.58.25-3.39,1.09-3.64,2a18.76,18.76,0,0,0,.46,9.41c1.37,3.62,2.29,5.93,3.08,7.49,0,0,6.85,2.94,12.38-.48,0,0,.37-3.89.4-6,5.1-4.45.74-9.93-3.58-14.19a8.14,8.14,0,0,0-1.56,0s3.86,4.55,1.18,7.14C18.49,258.94,17.35,256.36,15.51,255.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_14",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-12",
    d: "M26.82,241.75h0c-.57-3.62-3.19-6.35-6.92-6.14a7.22,7.22,0,0,0-6.77,7.62,7.14,7.14,0,0,0,3.16,5.51,7.59,7.59,0,0,0,.57,1.58c1.33,1.54,4.84,2.52,6,2.53,1,0,1.87-.92,2.81-2.48C27.62,247.13,27.13,243.54,26.82,241.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M18.74,235.68c-2.62.51-4.77,1.25-5.48,3.82-.49,1.77-1.13,5.15-.52,6.57l.38,1,3.17,1.64s1.48-1.24,1-4.85a2.57,2.57,0,0,1,.44-1.37,4,4,0,0,0,.44-1.1,4.06,4.06,0,0,1,2.06-2.22c2.36-1.33,5.82-.18,6.3.3A6.88,6.88,0,0,0,18.74,235.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M14,349.83c1.33,1.08,3.39.33,3.49.43A56.51,56.51,0,0,0,22.32,354c.83.65,2.12,1.52,1.89,2.77-.42,2.23-4,1.54-5.35.86s-2.45-1.82-3.72-2.61c-.91-.56-1.81-.86-2-2C13.1,352.29,13.75,349.8,14,349.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M13.21,352.52c.17,1.1,1.06,1.4,2,2,1.3.8,2.44,2,3.79,2.65s4.35,1.25,5.23-.34c-.48,2.15-4,1.48-5.33.8s-2.45-1.82-3.72-2.61c-.91-.56-1.81-.86-2-2A1.5,1.5,0,0,1,13.21,352.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M23.28,348c1.22,1,3,.43,3.14.52a49.08,49.08,0,0,0,4.44,3.39c.75.59,1.93,1.39,1.72,2.53-.38,2-3.66,1.42-4.89.79s-2.25-1.66-3.42-2.39c-.83-.51-1.65-.78-1.78-1.84A7.15,7.15,0,0,1,23.28,348Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M22.51,350.55c.16,1,1,1.29,1.79,1.8,1.19.74,2.24,1.8,3.47,2.43s4,1.15,4.79-.31c-.43,2-3.65,1.35-4.87.73s-2.25-1.66-3.42-2.39c-.83-.51-1.65-.78-1.78-1.84A1.59,1.59,0,0,1,22.51,350.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M30.43,286.31c-.59-4.57-2.27-11.21-2.27-11.21a13.55,13.55,0,0,1-5.07,1.25,41.2,41.2,0,0,1-7.67-.74,48,48,0,0,1-2.7,4.18c-1.32,1.83-3.89,5.84-3.27,12.84.41,4.58,3,24,3,24a36.27,36.27,0,0,0-1.57,10.08,83,83,0,0,0,1.6,12.08l1.53,11s2,1.47,3.49.43l-.18-10.8c.17-2.64.43-6.54.6-9,.28-4.05,1-10.49,1.21-12.09s.73-4.42,1-7.57,1.43-19.15,1.43-19.15l.17,3s.15,4.87.85,10.87.95,8.66.95,8.66A13,13,0,0,0,22.1,318c-.12,1.29-1.61,11.55-.72,16.77l1.82,13.27a3.48,3.48,0,0,0,3.14.41l1.07-13.37c.72-5.09,2.24-15.88,2.47-17.28a57.6,57.6,0,0,0,.91-8.56A185,185,0,0,0,30.43,286.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M15.41,274.19l-3.94,7.91s-6,8.79.22,31.39l-1.17,7s11.78,7.56,19.67,0c0,0,2.73-20.88,1.28-30.51a111.42,111.42,0,0,0-3.67-16.36s-1.93,2.13-11.87.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_15",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-12",
    d: "M40.05,279.81a23.09,23.09,0,0,0-3,.32,9.79,9.79,0,0,1-2.92.45c-1.08,0-4.09-1.5-6.67-3.31a30.78,30.78,0,0,1-7.16-7.59,67.14,67.14,0,0,1-5.29-9.8c-.84-2.42-.82-.77-2.25-.81-1.69,0-2.59.58-1.33,3.87a36.66,36.66,0,0,0,5.22,9.49,31.51,31.51,0,0,0,7.53,7.51,39.13,39.13,0,0,0,8.27,4.42c.84.34,1.38.81,2.9,1.65a10.88,10.88,0,0,0,5,1.43c1.46,0,2-.28,2.1-.58s-.13-.63-.8-.69a8.79,8.79,0,0,1-3.11-.62s1.45.21,2.33.25a8.72,8.72,0,0,0,2.35-.18c.74-.18,1.15-1.22.48-1.3s-1.22,0-2.52-.05a8.79,8.79,0,0,1-2-.37,16.38,16.38,0,0,0,2.61-.19,3.7,3.7,0,0,0,1.92-.77c.29-.24.34-.91-.51-.9a13,13,0,0,1-3.18.16c-1.05-.15-1.78-.4-1.62-.54s.78,0,1.66-.32,1.48-1.09,1.28-1.54S41,279.64,40.05,279.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M12.18,266.06s3.86.2,6.05-2.21l-2.38-5s-1.09-2.75-3.66-2.07S9.58,261.11,12.18,266.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M24.61,253.55s3.13-1,6.45,6l-1.24.75S26.55,255.32,24.61,253.55Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M78.55,109,23.21,77,23,76.88h0c-1.56-.83-3.67-.68-6,.66-4.77,2.76-8.64,9.46-8.64,15,0,2.85,1.05,4.82,2.72,5.67l56.09,32.37Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 72.92,
    cy: 119.81,
    rx: 12.22,
    ry: 7.05,
    transform: "translate(-67.3 123.05) rotate(-60)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "97.64 143.74 68.81 127.1 68.81 115.42 97.64 132.07 97.64 143.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "97.64 132.09 68.81 115.45 75.45 111.61 104.28 128.26 97.64 132.09"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 136.78,
    cy: 154.02,
    rx: 36.28,
    ry: 62.84,
    transform: "translate(-58.69 89.03) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M142.84,212.83c-29.75-17.18-54-59.11-54-93.47s24.21-48.33,54-31.15,54,59.11,54,93.46S172.6,230,142.84,212.83Zm0-104.94c-20.36-11.76-36.92-2.2-36.92,21.31s16.56,52.2,36.92,64,36.92,2.19,36.92-21.31S163.2,119.64,142.84,107.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M136.78,216.33c-29.76-17.18-54-59.11-54-93.47s24.2-48.33,54-31.15,54,59.11,54,93.46S166.53,233.51,136.78,216.33Zm0-104.94c-20.36-11.76-36.92-2.2-36.92,21.31s16.56,52.2,36.92,64,36.92,2.19,36.92-21.31S157.14,123.14,136.78,111.39Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.bed36c183ce66659b26aad86d2231326.svg";
export { ForwardRef as ReactComponent };